/** Overrides @basecom-gmbh/pond/composables/filter/useListingFiltersMapping.ts */
import type { ListingFilterMapping } from '../../types/listing/mapping';

export function useListingFiltersMapping() {
    const filterCodes = ['price', 'properties', 'sorting'];

    const componentsMapping: Record<string, string> = {
        price: 'ProductListingFilterPrice',
        properties: 'ProductListingFilterProperties',
    };

    // IDS-36 - Add mapping for sorting component
    const componentsMappingOffcanvas: Record<string, string> = {
        price: 'ProductListingFilterOptionsPrice',
        properties: 'ProductListingFilterOptionsProperties',
        sorting: 'ProductListingFilterOptionsSorting',
    };

    const componentsMappingBadge: Record<string, string> = {
        price: 'ProductListingFilterBadgePrice',
        properties: 'ProductListingFilterBadgeProperties',
    };

    const filterMapping: Record<string, () => ListingFilterMapping> = {
        price: usePriceFilter,
        properties: usePropertiesFilter,
    };

    return {
        filterCodes,
        componentsMapping,
        componentsMappingOffcanvas,
        componentsMappingBadge,
        filterMapping,
    };
}
